import { render } from "./IllustrationsList.vue?vue&type=template&id=51b9b63a"
import script from "./IllustrationsList.vue?vue&type=script&lang=js"
export * from "./IllustrationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__